// Shared calendar layout constants.
// SLOT_HEIGHT is the single source of truth for scheduler positioning math.
// Any file that renders time-based grid rows or computes event card positions
// must import from here — never hardcode the pixel value directly.

export const SLOT_HEIGHT = 40; // pixels per 30-minute slot (was 32 — increased for readability)
export const SLOTS_PER_DAY = 48; // 48 × 30 min = 24 hours
